import RegisterConnectDialog from './RegisterConnectDialogContainer';

export default RegisterConnectDialog;
